import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const Proceduress: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-neutral-2">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            viewBox="0 0 13 11"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-16 h-16 fill-white"
                        >
                            <path d="M5.4959 10.5156L1.25371 6.55469C1.15996 6.46094 1.06621 6.36719 0.972459 6.25H3.01152C3.55058 6.25 4.01933 5.94531 4.23027 5.45312L4.46465 4.86719L5.63652 7.42188C5.73027 7.63281 5.91777 7.75 6.12871 7.75C6.33965 7.75 6.55058 7.63281 6.64433 7.44531L7.65215 5.45312L7.67558 5.54688C7.90996 5.99219 8.35527 6.27344 8.84746 6.27344H11.3084C11.2146 6.36719 11.1209 6.46094 11.0271 6.55469L6.78496 10.5156C6.6209 10.6797 6.38652 10.75 6.15215 10.75C5.89433 10.75 5.65996 10.6797 5.4959 10.5156ZM11.9412 5.125H8.84746C8.77715 5.125 8.70683 5.10156 8.6834 5.03125L8.14433 3.95312C8.05058 3.76562 7.83965 3.625 7.62871 3.625C7.41777 3.625 7.23027 3.76562 7.13652 3.95312L6.15215 5.89844L4.95683 3.22656C4.88652 3.01562 4.67558 2.875 4.44121 2.89844C4.23027 2.89844 4.01933 3.01562 3.92558 3.22656L3.19902 5.03125C3.15215 5.10156 3.08183 5.14844 3.01152 5.14844H0.527146C0.456834 5.14844 0.409959 5.14844 0.339646 5.17188C0.222459 4.79688 0.152146 4.39844 0.152146 3.97656V3.85938C0.152146 2.21875 1.32402 0.8125 2.94121 0.554688C4.01933 0.367188 5.09746 0.71875 5.8709 1.46875L6.15215 1.75L6.4334 1.46875C7.1834 0.71875 8.28496 0.367188 9.33965 0.554688C10.9568 0.8125 12.1521 2.21875 12.1521 3.85938V3.97656C12.1521 4.375 12.0818 4.77344 11.9412 5.125Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={
                    <div className="font-700" id="vitals-left-id">
                        {sectionName || 'Procedures'}
                    </div>
                }
                key="procedures "
            >
                <p className="mr-16 space-y-2">
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    procedures_in_unbold: !rxConfig?.procedures_in_unbold,
                                });
                            }}
                        >
                            <span>Make the procedures name bold</span>
                            <Checkbox checked={!rxConfig?.procedures_in_unbold}></Checkbox>
                        </p>
                    </div>

                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    bullets_config: {
                                        ...rxConfig?.bullets_config,
                                        ['procedures']: !rxConfig?.bullets_config?.['procedures'],
                                    },
                                    tabular_config: {
                                        ...rxConfig?.tabular_config,
                                        ['procedures']: false,
                                    },
                                });
                            }}
                        >
                            <span>Use bullet points</span>
                            <Checkbox
                                checked={
                                    rxConfig?.bullets_config?.['procedures'] &&
                                    !rxConfig?.tabular_config?.['procedures']
                                }
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    bullets_config: {
                                        ...rxConfig?.bullets_config,
                                        ['procedures']: false,
                                    },
                                    tabular_config: {
                                        ...rxConfig?.tabular_config,
                                        ['procedures']: !rxConfig?.tabular_config?.['procedures'],
                                    },
                                });
                            }}
                        >
                            <span>Use tabular format</span>
                            <Checkbox
                                checked={
                                    !rxConfig?.bullets_config?.['procedures'] &&
                                    rxConfig?.tabular_config?.['procedures']
                                }
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.procedures_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        procedures_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            procedures_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    {!(
                        !rxConfig?.bullets_config?.['procedures'] &&
                        rxConfig?.tabular_config?.['procedures']
                    ) ? (
                        <>
                            <div className="flex items-center justify-between">
                                <div>Key Elements</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={rxConfig?.procedures_name_color || '#000000'}
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                procedures_name_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    procedures_name_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                            <div className="flex items-center justify-between">
                                <div>Properties</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={rxConfig?.procedures_properties_color || '#000000'}
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                procedures_properties_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    procedures_properties_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                        </>
                    ) : (
                        <></>
                    )}
                </p>
            </Panel>
        </Collapse>
    );
};

export default Proceduress;
